/**

 * Infinite product slider for featured collection (desktop).

 * Standard clone-strip implementation:

 * - prepend clones of the last `cloneCount` products (for prev from start)

 * - append clones of the first `cloneCount` products (for next past end)

 * - start at index = cloneCount (first real slide)

 * - on wrap, snap (no transition) back into the real range

 */

(function () {

  var MOBILE_MQ = '(max-width: 768px)';

  var TRANSITION_MS = 450;



  function getSlides(track) {

    return Array.prototype.slice.call(track.querySelectorAll(':scope > .grid__item.grid-product'));

  }



  function stripClones(track) {

    track.querySelectorAll('.grid__item.grid-product.is-slider-clone').forEach(function (node) {

      node.remove();

    });

  }



  function setCloneInteractive(slide, interactive) {

    if (interactive) {

      slide.classList.add('is-slider-clone--interactive');

      slide.removeAttribute('aria-hidden');

      slide.querySelectorAll('form').forEach(function (form) {

        form.removeAttribute('aria-hidden');

        form.querySelectorAll('button, input, select, textarea').forEach(function (control) {

          control.removeAttribute('tabindex');

          control.disabled = false;

        });

      });

      slide.querySelectorAll('a').forEach(function (link) {

        link.removeAttribute('tabindex');

      });

      return;

    }

    slide.classList.remove('is-slider-clone--interactive');

    slide.setAttribute('aria-hidden', 'true');

    slide.querySelectorAll('form').forEach(function (form) {

      form.setAttribute('aria-hidden', 'true');

      form.querySelectorAll('button, input, select, textarea').forEach(function (control) {

        control.setAttribute('tabindex', '-1');

        control.disabled = true;

      });

    });

    slide.querySelectorAll('a').forEach(function (link) {

      link.setAttribute('tabindex', '-1');

    });

  }



  function cloneSlide(slide) {

    var clone = slide.cloneNode(true);

    clone.classList.add('is-slider-clone');

    clone.setAttribute('aria-hidden', 'true');

    clone.removeAttribute('data-index');

    clone.querySelectorAll('[id]').forEach(function (el) {

      el.removeAttribute('id');

    });

    setCloneInteractive(clone, false);

    return clone;

  }



  function fixSliderButtonStyles(root) {

    var selector =

      '.featured-collection-slider__track > .grid__item.grid-product:not(.is-slider-clone), ' +

      '.featured-collection-slider__track > .grid__item.grid-product.is-slider-clone--interactive';

    root.querySelectorAll(selector).forEach(function (slide) {

      slide.querySelectorAll('button.add-to-cart').forEach(function (btn) {

        btn.classList.add('btn--static');

        btn.querySelectorAll('[data-add-to-cart-text], span').forEach(function (label) {

          label.style.setProperty('color', '#ffffff', 'important');

          label.style.setProperty('-webkit-text-fill-color', '#ffffff', 'important');

        });

      });

    });

  }



  function initSlider(root) {

    if (root.dataset.sliderReady === 'true') return;

    if (window.matchMedia(MOBILE_MQ).matches) return;

    var viewport = root.querySelector('.featured-collection-slider__viewport');

    var track = root.querySelector('.featured-collection-slider__track');

    var prevBtn = root.querySelector('.featured-collection-slider__nav--prev');

    var nextBtn = root.querySelector('.featured-collection-slider__nav--next');

    if (!viewport || !track || !prevBtn || !nextBtn) {

      return;

    }

    var visible = parseInt(root.dataset.visible, 10) || 4;

    var realSlides = getSlides(track).filter(function (slide) {

      return !slide.classList.contains('is-slider-clone');

    });

    var realCount = realSlides.length;

    if (realCount <= visible) return;

    var cloneCount = Math.min(visible, realCount);

    root.dataset.sliderReady = 'true';

    root.style.setProperty('--fc-slider-visible', String(visible));

    stripClones(track);

    realSlides = getSlides(track);

    realCount = realSlides.length;

    cloneCount = Math.min(visible, realCount);

    // Head: last N products (so prev from first view reveals product N on the left)

    var head = realSlides.slice(-cloneCount);

    for (var i = head.length - 1; i >= 0; i--) {

      track.insertBefore(cloneSlide(head[i]), track.firstChild);

    }

    // Tail: first N products (so next past last view reveals product 1 on the right)

    var tail = realSlides.slice(0, cloneCount);

    tail.forEach(function (slide) {

      track.appendChild(cloneSlide(slide));

    });

    var allSlides = getSlides(track);

    var index = cloneCount; // first real slide

    var animating = false;

    var transitionTimer = null;

    var resizeObserver = null;

    function slideWidth() {

      // Any real slide should match width; measuring at the first real slide is stable.

      var measure = allSlides[cloneCount] || allSlides[0];

      return measure ? measure.getBoundingClientRect().width : 0;

    }

    function updateCloneInteraction() {

      var start = index;

      var end = index + visible; // visible cards in viewport

      allSlides.forEach(function (slide, idx) {

        if (!slide.classList.contains('is-slider-clone')) return;

        setCloneInteractive(slide, idx >= start && idx < end);

      });

    }

    function setPosition(animated) {

      var width = slideWidth();

      if (!width) return false;

      track.style.transition = animated

        ? 'transform ' + TRANSITION_MS + 'ms cubic-bezier(0.25, 0.46, 0.45, 0.94)'

        : 'none';

      track.style.transform = 'translate3d(' + (-index * width) + 'px, 0, 0)';

      updateCloneInteraction();

      return true;

    }

    function normalizeIndexAfterTransition() {

      // Real slides occupy [cloneCount, cloneCount + realCount - 1]

      // Only snap at true loop boundaries — not after a single prev into index 3, etc.

      if (index >= cloneCount + realCount) {

        index -= realCount;

        setPosition(false);

        return;

      }

      if (index <= 0) {

        index += realCount;

        setPosition(false);

      }

    }

    function endTransition() {

      if (transitionTimer) {

        window.clearTimeout(transitionTimer);

        transitionTimer = null;

      }

      if (!animating) return;

      animating = false;

      normalizeIndexAfterTransition();

      fixSliderButtonStyles(root);

    }

    function applyLayout() {

      if (!setPosition(false)) return false;

      fixSliderButtonStyles(root);

      return true;

    }

    function go(direction) {

      if (animating) return;

      animating = true;

      index += direction;

      setPosition(true);

      transitionTimer = window.setTimeout(endTransition, TRANSITION_MS + 80);

    }

    function onTransitionEnd(e) {

      if (e.target !== track || e.propertyName !== 'transform') return;

      endTransition();

    }

    function onResize() {

      if (window.matchMedia(MOBILE_MQ).matches) {

        destroySlider(root);

        return;

      }

      setPosition(false);

    }

    prevBtn.addEventListener('click', function () {

      go(-1);

    });

    nextBtn.addEventListener('click', function () {

      go(1);

    });

    track.addEventListener('transitionend', onTransitionEnd);

    window.addEventListener('resize', onResize);

    root._fcSliderResize = onResize;

    root._fcSliderTransitionEnd = onTransitionEnd;

    if (!applyLayout()) {

      resizeObserver = new ResizeObserver(function () {

        if (applyLayout() && resizeObserver) {

          resizeObserver.disconnect();

          resizeObserver = null;

        }

      });

      resizeObserver.observe(viewport);

    }

    window.addEventListener(

      'load',

      function onLoad() {

        applyLayout();

      },

      { once: true }

    );

    root._fcSliderResizeObserver = resizeObserver;

  }



  function destroySlider(root) {

    var track = root.querySelector('.featured-collection-slider__track');

    if (root._fcSliderResizeObserver) {

      root._fcSliderResizeObserver.disconnect();

      root._fcSliderResizeObserver = null;

    }

    if (track && root._fcSliderTransitionEnd) {

      track.removeEventListener('transitionend', root._fcSliderTransitionEnd);

      root._fcSliderTransitionEnd = null;

    }

    if (!track) return;

    stripClones(track);

    track.style.transform = '';

    track.style.transition = '';

    root.dataset.sliderReady = '';

    root.style.removeProperty('--fc-slider-visible');

    if (root._fcSliderResize) {

      window.removeEventListener('resize', root._fcSliderResize);

      root._fcSliderResize = null;

    }

  }



  function initAll() {

    document.querySelectorAll('[data-featured-collection-slider]').forEach(function (root) {

      destroySlider(root);

      initSlider(root);

    });

  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initAll);

  } else {

    initAll();

  }

  document.addEventListener('shopify:section:load', function (event) {

    if (event.target.querySelector('[data-featured-collection-slider]')) initAll();

  });

})();

